export default {}

export const queryFormatter = (obj = {}) => Object.entries(obj)
  .reduce((total, [key, val]) => val === undefined ? total : `${total}${encodeURIComponent(key)}=${encodeURIComponent(val)}&`,
    '?')
  .slice(0, -1);

// 防抖
export const debounce = (fn, delay) => {
  // 记录上一次的延时器
  let dbcTimer = null;
  return function () {
    // 清除上一延时器
    clearTimeout(dbcTimer);
    // 重新设置新的延时器
    dbcTimer = setTimeout(function () {
      fn.apply(this);
    }, delay);
  };
};


/**
 * @description 获取当前时间
 * @param {string} format
 * @returns {string}
 */
export const getNowDate = (timestamp = '', format) => {
  let result = ''
  let tempDate = new Date()
  if (timestamp) {
    tempDate = new Date(timestamp)
  }

  const year = tempDate.getFullYear()
  const month = tempDate.getMonth() + 1 >= 10 ? tempDate.getMonth() + 1 : '0' + (tempDate.getMonth() + 1)
  const date = tempDate.getDate() >= 10 ? tempDate.getDate() : '0' + tempDate.getDate()
  const hour = tempDate.getHours() >= 10 ? tempDate.getHours() : '0' + tempDate.getHours()
  const minutes = tempDate.getMinutes() >= 10 ? tempDate.getMinutes() : '0' + tempDate.getMinutes()
  const seconds = tempDate.getSeconds() >= 10 ? tempDate.getSeconds() : '0' + tempDate.getSeconds()

  switch (format) {
    case 'yyyy-MM-dd HH:mm:ss':
      result = `${year}-${month}-${date} ${hour}:${minutes}:${seconds}`
      break
    case 'yyyy~MM~dd HH:mm:ss':
      result = `${year}年${month}月${date}日 ${hour}:${minutes}:${seconds}`
      break
    case 'yyyy-MM-dd':
      result = `${year}-${month}-${date}`
      break
    case 'yyyy/MM/dd':
      result = `${year}/${month}/${date}`
      break
    case 'yyyy/MM/dd HH:mm:ss':
      result = `${year}/${month}/${date} ${hour}:${minutes}:${seconds}`
      break
    case 'timestamp':
      result = this.date2TimeStamp(tempDate)
      break
    default:
      result = `${year}-${month}-${date} ${hour}:${minutes}:${seconds}`
      break
  }
  return result
}